import React from "react"
import LogoWithNavigation from "../../_/LogoWithNav/LogoWithNav.component"
import { ServicePageHeaderStyled } from "./css/ServicePageHeaderStyled.css"
import CenterContainer from "../../../../../layouts/containers/CenterContainer/CenterContainer.component";
import MainCtaButton from "../../../_/buttons/MainCtaButton/MainCtaButton.component";

interface ServicePageHeaderProps {
  data?: {
    heading?: string,
    buttonText?: string,
    rightHeroImage?: string,
    backgroundColor?: string,
    headerIcon?: string,
    textColor?: string
  }
  desktopMainMenuTextColor?: string;
}

const ServicePageHeader: React.FC<ServicePageHeaderProps> = (props) => (

  <ServicePageHeaderStyled 
    rightHeroImage={props.data?.rightHeroImage || undefined}
    backgroundColor={props.data?.backgroundColor || undefined}
    headerIcon={props.data?.headerIcon || undefined}
    textColor={props.data?.textColor || undefined}
  >

    <CenterContainer>

      <LogoWithNavigation desktopMainMenuTextColor={props.desktopMainMenuTextColor ?? undefined} />

      <div className="hero-container">

        <div className="content">

          <div className="content--center-y">

            <div className="service-page-header-icon"></div>

            <h1 className="heading">{props.data && props.data.heading || "Heading placeholder"}</h1>

            <MainCtaButton buttonText={props.data?.buttonText || "Hire Us"} />

          </div>

        </div>

        <div className="right-hero-container"></div>

      </div>

    </CenterContainer>

  </ServicePageHeaderStyled>

)

export default ServicePageHeader;